import './App.css';
import React from 'react';
import NavBar from './components/NavBar';
import TextForm from './components/TextForm';
import {useState} from 'react';
import Alert from './components/Alert';

function App() {
  const [mode,setMode] = useState("light"); 
  const [alert,setAlert] = useState(null);
  const showAlert = (message,type)=>{
    setAlert({
      msg:message,
      type:type
    })
    setTimeout(()=>{
      setAlert(null)
    },1500);
  }
  const toggleMode = ()=>{
    if(mode==="light"){
      setMode("dark");
      document.body.style.backgroundColor = "#042743";
      document.body.style.color = "white";
      showAlert("Dark Mode Has Been Enabled.","success")
    }
    else if(mode==="dark"){
      setMode("light")
      document.body.style.backgroundColor = "white";
      document.body.style.color = "black";
      showAlert("Light Mode Has Been Enabled.","success")
    }
  }
  const primaryMode = ()=>{
    setMode("primary");
    document.body.style.backgroundColor="primary";
    showAlert("Primary Mode Has Been Enabled.","success")
  }
  return (
    <>
    <NavBar title="TextUtils" textAbout="About TextUtils" mode={mode} toggleMode={toggleMode} primaryMode={primaryMode}/>
    <Alert alert={alert}/>
    <div className="container my-3">
            <TextForm heading="Enter the text to analyze below" mode={mode} showAlert={showAlert}/>
    </div>
    </>
  );
}
export default App;
